const mPInvitationList = state => state.mPInvitationList;
const mpInvitationNextPage = state => state.mpInvitationNextPage;
const mPRequestedBy = state => state.mPRequestedBy;
const newNotifsCount = state => state.newNotifsCount;
const allNotifsCount = state => state.allNotifsCount;
const newNotifications = state => state.newNotifications;
const readNotifications = state => state.readNotifications;
const allNotifications = state => state.allNotifications;
const currentNotification = state => state.currentNotification;

export default {
  newNotifsCount,
  allNotifsCount,
  mPInvitationList,
  mpInvitationNextPage,
  mPRequestedBy,
  newNotifications,
  readNotifications,
  allNotifications,
  currentNotification,
};
